import { createFileRoute } from "@tanstack/react-router";
import { PhotographyServicePage } from "./services_.photography";

export const Route = createFileRoute("/services_/branding-creatives-and-photography-copywriting-services")({
  head: () => ({
    meta: [
      {
        title: "Photography & Copywriting Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Commercial Photography & Persuasive Copywriting Services.",
      },
    ],
  }),
  component: PhotographyServicePage,
});
